import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BenjiKIV} from "../BenjiKIV";
import {BenjiKIVGameAssets} from "../BenjiKIVGameAssets";
import {BenjiKIVStatics} from "../BenjiKIVStatics";
import {gsap} from "gsap";

/**
 * Created by Jerker Nord on 2023-02-03.
 */

export class BenjiKIVAnticipationView extends PIXI.Container implements StageLayer {

    private _deadAnticipation:PIXI.Sprite[];
    private _showDeadTLs:gsap.core.Timeline[];
    private _hideDeadTLs:gsap.core.Timeline[];
    private _diceAnticipation:PIXI.Sprite[];
    private _showDiceTLs:gsap.core.Timeline[];
    private _hideDiceTLs:gsap.core.Timeline[];

    constructor() {
        super();
        this.name = "BenjiKIVAnticipationView";
        this.position = BenjiKIVStatics.MAIN_REELS_VIEW_POSITION;

        this.init();
    }

    private init():void {
        this._showDeadTLs = [];
        this._hideDeadTLs = [];
        this._deadAnticipation = [];
        this._showDiceTLs = [];
        this._hideDiceTLs = [];
        this._diceAnticipation = [];
        for(let i:number = 0; i < 5; i++) {
            let tempSprite:PIXI.Sprite;
            tempSprite = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures(BenjiKIVGameAssets.DEAD_REEL_ATTENTION)[0]);
            tempSprite.position.x = (i * BenjiKIVStatics.symbolWidth);
            tempSprite.position.y = 506;
            tempSprite.anchor.set(0.5, 0.5);
            tempSprite.angle = 180;
            tempSprite.blendMode = PIXI.BLEND_MODES.ADD;
            tempSprite.visible = false;
            this._deadAnticipation.push(tempSprite);
            this.addChild(tempSprite);

            this._showDeadTLs.push(this.createShowDeadTL(i));
            if(i == 4) {
                this._hideDeadTLs.push(this.createHideDeadTL(i, 0.2));
            } else {
                this._hideDeadTLs.push(this.createHideDeadTL(i));
            }

            let tempSprite2:PIXI.Sprite;
            tempSprite2 = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures(BenjiKIVGameAssets.XSPLIT_REEL_ATTENTION)[0]);
            tempSprite2.position.x = (i * BenjiKIVStatics.symbolWidth);
            tempSprite2.position.y = 506;
            tempSprite2.anchor.set(0.5, 0.5);
            tempSprite2.angle = 180;
            tempSprite2.blendMode = PIXI.BLEND_MODES.ADD;
            tempSprite2.visible = false;
            this._diceAnticipation.push(tempSprite2);
            this.addChild(tempSprite2);

            this._showDiceTLs.push(this.createShowDiceTL(i));
            if(i == 4) {
                this._hideDiceTLs.push(this.createHideDiceTL(i, 0.2));
            } else {
                this._hideDiceTLs.push(this.createHideDiceTL(i));
            }
        }
    }

    private createShowDeadTL(reelId:number):gsap.core.Timeline {
        const showTL:gsap.core.Timeline = gsap.timeline({paused : true});
        showTL.add(() => {this._deadAnticipation[reelId].alpha = 0});
        showTL.add(() => {this._deadAnticipation[reelId].visible = true});
        showTL.add(gsap.to(this._deadAnticipation[reelId], {duration : 0.1, alpha : 1}));
        showTL.add(() => {this._deadAnticipation[reelId].alpha = 1});
        return showTL;
    }

    private createHideDeadTL(reelId:number, duration:number = 0.3):gsap.core.Timeline {
        const hideTL:gsap.core.Timeline = gsap.timeline({paused : true});
        hideTL.add(() => {this._deadAnticipation[reelId].alpha = 1});
        hideTL.add(gsap.to(this._deadAnticipation[reelId], {duration : duration, alpha : 0}));
        hideTL.add(() => {this._deadAnticipation[reelId].visible = false});
        return hideTL;
    }

    public getShowDeadTL(reelId:number):gsap.core.Timeline {
        return this._showDeadTLs[reelId];
    }

    public getHideDeadTL(reelId:number):gsap.core.Timeline {
        return this._hideDeadTLs[reelId];
    }

    private createShowDiceTL(reelId:number):gsap.core.Timeline {
        const showTL:gsap.core.Timeline = gsap.timeline({paused : true});
        showTL.add(() => {this._diceAnticipation[reelId].alpha = 0});
        showTL.add(() => {this._diceAnticipation[reelId].visible = true});
        showTL.add(gsap.to(this._diceAnticipation[reelId], {duration : 0.1, alpha : 1}));
        showTL.add(() => {this._diceAnticipation[reelId].alpha = 1});
        return showTL;
    }

    private createHideDiceTL(reelId:number, duration:number = 0.3):gsap.core.Timeline {
        const hideTL:gsap.core.Timeline = gsap.timeline({paused : true});
        hideTL.add(() => {this._diceAnticipation[reelId].alpha = 1});
        hideTL.add(gsap.to(this._diceAnticipation[reelId], {duration : duration, alpha : 0}));
        hideTL.add(() => {this._diceAnticipation[reelId].visible = false});
        return hideTL;
    }

    public getShowDiceTL(reelId:number):gsap.core.Timeline {
        return this._showDiceTLs[reelId];
    }

    public getHideDiceTL(reelId:number):gsap.core.Timeline {
        return this._hideDiceTLs[reelId];
    }
}